import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import grnReducer from "./grn";

const store = configureStore({
  reducer: {
    auth: authReducer,
    grn: grnReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
